import { Routes } from '@angular/router';
import { AuthGuard } from '@shared/auth/auth.guard';
import { CeremaLayout } from '@shared/layouts/cerema-layout/components/cerema.layout';
import { RouteMeta as LicensesRouteMeta } from './pages/(cerema)/!licenses.route';
import { RouteMeta as OrganizationsRouteMeta } from './pages/(cerema)/!organizations.route';
import { RouteMeta as SubscriptionsRouteMeta } from './pages/(cerema)/!subscriptions.route';
import { RouteMeta as ApplicationsRouteMeta } from './pages/(cerema)/!applications.route';
import { RouteMeta as AuditRouteMeta } from './pages/(cerema)/!audit.route';
import { RouteMeta as OffersRouteMeta } from './pages/(cerema)/!offers.route';

// AUTO-GENERATED ROUTES - Do not edit manually
// Generated from: src/app/pages
// To disable filesystem routing, set routing.enabled = false in front.config.ts
export const AUTO_ROUTES: Routes = [
  {
    path: 'home',
  loadComponent: () => import('./pages/home.page').then(m => m.HomePage)
  },
  {
    path: '',
  component: CeremaLayout,
  children: [
    {
      path: 'licenses',
    ...LicensesRouteMeta,
    loadComponent: () => import('./pages/(cerema)/!licenses.page').then(m => m.LicensesPage)
    },
    {
      path: 'organizations',
    ...OrganizationsRouteMeta,
    loadComponent: () => import('./pages/(cerema)/!organizations.page').then(m => m.OrganizationsPage)
    },
    {
      path: 'dashboard',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/(cerema)/!dashboard.page').then(m => m.DashboardPage)
    },
    {
      path: 'subscriptions',
    ...SubscriptionsRouteMeta,
    loadComponent: () => import('./pages/(cerema)/!subscriptions.page').then(m => m.SubscriptionsPage)
    },
    {
      path: 'applications',
    ...ApplicationsRouteMeta,
    loadComponent: () => import('./pages/(cerema)/!applications.page').then(m => m.ApplicationsPage)
    },
    {
      path: 'audit',
    ...AuditRouteMeta,
    loadComponent: () => import('./pages/(cerema)/!audit.page').then(m => m.AuditPage)
    },
    {
      path: 'offers',
    ...OffersRouteMeta,
    loadComponent: () => import('./pages/(cerema)/!offers.page').then(m => m.OffersPage)
    }
  ]
  }
];
